<div class= "col-lg-8 col-lg-3 text-uppercase" style="margin-left:700px; margin-bottom:-90px; margin-top:0px;
font-weight: bold;font-size: 25px; color: #6c7c97;" >{{'' | i18n: 'upload-warranty-contracts'}}</div>
<div class="col-lg-3"  >
  <div class= "col-lg-3 text-uppercase" style="font-weight: bold;font-size: 25px; color: #6c7c97; margin-left:700px;margin-top: 250px;">
    {{'' | i18n: 'upload-warranty-contracts'}}
  </div>
  <div class="col-lg-3" style="margin-top: 50px "  >
    <p >{{'' | i18n: 'bulk-upload-file'}}</p>
    @if (isAdmin()) {
      <div class="container" appFileDnD (fileDropped)="onFileDropped($event)">
        <input type="file" #fileDropRef id="fileDropRef"  accept=".csv" style="margin-top:200px;"
          (change)="fileBrowseHandler($event.target.files)" multiple= false/>
          <h3>{{'' | i18n: 'warranty-condition-drag-drop'}}</h3><br/>
          <label for="fileDropRef">{{'' | i18n: 'bulk-browse'}}</label>
        </div>
      }
    </div>

  </div>
